module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.site_view == 1) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0"
    }
  }, [(_vm.set_show_header) ? _c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [(_vm.set_inner_view == '') ? _c('h4', {
    staticStyle: {
      "float": "left",
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("Settings")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), ((_vm.menu_tab_inner_view['setProfile'] && (_vm.set_inner_view == '')) || (_vm.menu_tab_inner_view['setProfile'] && (_vm.site_view == 2))) ? _c('div', [_c('div', {
    staticClass: "col-md-4 col-xs-12 mp0"
  }, [(_vm.site_view == 1 && (_vm.set_inner_view == '')) ? _c('div', [_c('div', {
    staticClass: "card-box-row"
  }, [_c('p', {
    staticClass: "card-menu-box",
    staticStyle: {
      "float": "left",
      "width": "35%",
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_inner_view = 'setContactInformation'
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('p', {
    staticClass: "card-menu-box",
    staticStyle: {
      "float": "right",
      "width": "55%",
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_inner_view = 'setContactInformation'
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-box-row",
    staticStyle: {
      "margin-top": "-1.3em"
    }
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Profile")]), _vm._v(" "), (Object.keys(_vm.user).length > 0) ? _c('div', {
    staticClass: "card-box-box",
    staticStyle: {
      "background-color": "#f8f7f0",
      "border-radius": "8px",
      "padding": "0 1em",
      "padding-bottom": "1.42em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), (_vm.user.user_phone && (_vm.user.user_phone != '')) ? _c('p', [_vm._v(_vm._s(_vm.user.user_phone))]) : (_vm.user.user_email && (_vm.user.user_email != '')) ? _c('p', [_vm._v(_vm._s(_vm.user.user_email))]) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((_vm.site_view == 1)) ? _c('div', {
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#ffe600"
    },
    on: {
      "click": function($event) {
        _vm.prepSetView(2)
      }
    }
  }, [_vm._v("View Profile")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-box-row"
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Delivery Address")]), _vm._v(" "), (Object.keys(_vm.user).length > 0) ? _c('div', {
    staticClass: "card-box-box",
    staticStyle: {
      "background-color": "#ffe600",
      "border-radius": "8px",
      "padding": "1em",
      "padding-bottom": "1em"
    }
  }, [_c('div', [(_vm.user.user_delivery_address && (_vm.user.user_delivery_address != '')) ? _c('p', [_vm._v(_vm._s(_vm.user.user_delivery_address))]) : _c('p', [_vm._v("Set Delivery address and location for your orders")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]), _vm._v(" "), ((_vm.site_view == 2)) ? _c('div', {
    staticClass: "card-box-row"
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Other Settings")]), _vm._v(" "), (Object.keys(_vm.user).length > 0) ? _c('div', {
    staticClass: "card-box-box c-box-02",
    staticStyle: {
      "background-color": "#ffe600",
      "border-radius": "8px",
      "padding": "1em",
      "padding-bottom": "1em",
      "padding-top": "0.8em"
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), ((Object.keys(_vm.sellpoints).length > 0)) ? _c('p', [_vm._m(8)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 1) ? _c('div', {
    staticClass: "col-md-4 col-xs-12 mp0"
  }, [(_vm.site_user_type == 1 || (_vm.menu_tab_inner_view['setProfile'])) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em 0.2em",
      "margin-top": "-1.50em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [((_vm.set_inner_view == '')) ? _c('div', {
    staticClass: "cardboxx"
  }, [_c('div', {
    staticClass: "card-box-row"
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(2)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(10)
      }
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/login"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [(_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('span', [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])]) : _c('span', [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Login")])])]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 2 && (!_vm.menu_tab_inner_view['setProfile'])) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em 0.2em",
      "margin-top": "-1.50em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.site_view == 2 || (_vm.set_inner_view == '')) ? _c('div', {
    staticClass: "cardboxx"
  }, [_c('div', {
    staticClass: "card-box-row",
    staticStyle: {
      "margin-top": "1.3em"
    }
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v(_vm._s(_vm.set_str_attr.business.name) + " Settings")]), _vm._v(" "), (Object.keys(_vm.sellpoint).length > 0) ? _c('div', {
    staticClass: "card-box-box",
    staticStyle: {
      "background-color": "#f8f7f0",
      "border-radius": "8px",
      "padding": "0 1em",
      "padding-bottom": "1.42em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), (_vm.sellpoint.business_contact_phone && (_vm.sellpoint.business_contact_phone != '')) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_contact_phone))]) : (_vm.sellpoint.business_contact_email && (_vm.sellpoint.business_contact_email != '')) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_contact_email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-avatar-circle-xx",
    staticStyle: {
      "float": "right",
      "text-align": "center",
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(7)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#ffe600"
    },
    on: {
      "click": function($event) {
        _vm.prepSetView(5)
      }
    }
  }, [_vm._v("View Business Details")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-box-row"
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Business Location and Address")]), _vm._v(" "), (Object.keys(_vm.user).length > 0) ? _c('div', {
    staticClass: "card-box-box",
    staticStyle: {
      "background-color": "#ffe600",
      "border-radius": "8px",
      "padding": "1em",
      "padding-bottom": "1em"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('b', [_vm._v("Location: ")]), _vm._v(" "), (_vm.sellpoint.business_location_name && (_vm.sellpoint.business_location_name != '')) ? _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_location_name))]) : _c('span', [_vm._v("Not Set")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('b', [_vm._v("Address: ")]), _vm._v(" "), (_vm.sellpoint.business_address && (_vm.sellpoint.business_address != '')) ? _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('span', [_vm._v("Not Set")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "margin-top": "-1.62em",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "text-align": "center",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#000000",
      "color": "#f5f5f5"
    },
    on: {
      "click": function($event) {
        _vm.prepSetView(6)
      }
    }
  }, [_vm._v("Set")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-box-row"
  }, [_c('h5', {
    staticClass: "intro-xs"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(5)
      }
    }
  }, [_vm._m(17), _vm._v(" "), _vm._m(18)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(8)
      }
    }
  }, [_vm._m(19), _vm._v(" "), _vm._m(20)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(9)
      }
    }
  }, [_vm._m(21), _vm._v(" "), _vm._m(22)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/login"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [(_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('span', [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])]) : _c('span', [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Login")])])]), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-x"
  }, [(_vm.site_view == 2 && !_vm.menu_tab_inner_view['setProfile']) ? _c('div', {
    staticClass: "col-md-4 col-xs-12 mp0",
    attrs: {
      "id": "cardSidebar"
    }
  }, [(_vm.site_view == 2 || (_vm.set_inner_view == '')) ? _c('div', {
    staticClass: "cardboxx cardmenu card-desktop-sidemenu"
  }, [(_vm.site_user_type == 2) ? _c('div', [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(5)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Business Details")]), _vm._v(" "), _vm._m(25)])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(7)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Business Page Photo ")]), _vm._m(26)])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(8)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Delivery Places ")]), _vm._m(27)])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(9)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Bank Information ")]), _vm._m(28)])])]) : (_vm.site_user_type == 1) ? _c('div', [_c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(2)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Contact Details")]), _vm._v(" "), _vm._m(29)])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(4)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Delivery Locations ")]), _vm._m(30)])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.prepSetView(10)
      }
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Reset Password ")]), _vm._m(31)])]), _vm._v(" "), _vm._m(32)]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-x"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12 mp0",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {
    staticClass: "card-side-details"
  }, [_c('div', {
    staticClass: "cardbox"
  }, [(!((_vm.site_view == 2) && (_vm.set_inner_view == 'setProfileDetails'))) ? _c('div', [(_vm.set_show_back) ? _c('h1', {
    staticStyle: {
      "margin-top": "-0.31em"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setProfileDetails') ? _c('div', [_c('h4', [_vm._v("Profile Details")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.user_name))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.user_email))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Phone Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.user_phone))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#ffe600"
    },
    on: {
      "click": function($event) {
        _vm.prepSetView(3);
      }
    }
  }, [_vm._v("Edit Profile")])])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setBusinessDetails') ? _c('div', [_c('h4', [_vm._v("Business Profile Details")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_contact_email))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Phone Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_contact_phone))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_address))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Location")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_location_name))]), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#ffe600"
    },
    on: {
      "click": function($event) {
        _vm.prepSetView(6);
      }
    }
  }, [_vm._v("Edit Profile")])])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setEditBusinessDetails') ? _c('div', [_c('div', {
    staticClass: "cardbox-x"
  }, [_c('h4', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_phone),
      expression: "sellpoint.business_contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_email),
      expression: "sellpoint.business_contact_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [(_vm.sellpoint.business_location_name && (_vm.sellpoint.business_location_name != '')) ? _c('div', {
    staticClass: "card"
  }, [_c('p', [_c('b', [_vm._v("Location: ")]), _vm._v(_vm._s(_vm.sellpoint.business_location_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_state),
      expression: "sellpoint.business_state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sellpoint.business_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.sellpoint.business_state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading && ((_vm.sellpoint.business_state > 0) && (Object.keys(_vm.cities).length == 0))) ? _c('div', [_c('p', [_vm._v("...loading locations")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_location_city),
      expression: "sellpoint.business_location_city"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sellpoint.business_location_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.data_processing_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('', 1)
      }
    }
  }, [_vm._v("Save Details \r\n                    "), (((_vm.action_loading) && (_vm.sellpoint.business_state > 0) && (_vm.cities.length > 0)) || ((_vm.action_loading) && (!_vm.sellpoint.business_state))) ? _c('span', [_c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setBusinessDisplayPhoto') ? _c('div', [_c('div', {
    staticClass: "cardbox-x"
  }, [_c('h4', [_vm._v("Set Business Page Photo")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('img', {
    staticClass: "rounded img-responsive",
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_banner_image')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setBankInformation') ? _c('div', [_c('div', {
    staticClass: "cardbox-x"
  }, [_c('h2', [_vm._v("Bank Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(33)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setBankDetails()
      }
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setBusinessDeliveryLocations') ? _c('div', [_c('div', {
    staticClass: "cardbox-x"
  }, [_c('h2', [_vm._v("Delivery Settings and Locations")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [(_vm.sellpoint.business_offer_delivery && (_vm.sellpoint.business_offer_delivery == 1)) ? _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "0.2em",
      "line-height": "0.52",
      "border": "#333 1px solid",
      "border-radius": "5px"
    },
    on: {
      "click": function($event) {
        _vm.sellpoint.business_offer_delivery = 0;
        _vm.editBusinessDetails('offer_delivery');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  })]) : _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "0.2em",
      "line-height": "0.52",
      "border": "#333 1px solid",
      "border-radius": "5px"
    },
    on: {
      "click": function($event) {
        _vm.sellpoint.business_offer_delivery = 1;
        _vm.editBusinessDetails('offer_delivery');
      }
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v("Do you offer Delivery ?")])]), _vm._v(" "), _c('div', [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                        "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                          "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(34)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'setContactInformation') ? _c('div', [_c('div', {
    staticClass: "cardbox-x"
  }, [_c('h4', [_vm._v("Edit Profile Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data_user.user_name),
      expression: "data_user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.data_user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data_user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), ((!_vm.user.user_phone || (_vm.user.user_phone == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data_user.user_phone),
      expression: "data_user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.data_user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data_user.user_phone = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), ((!_vm.user.user_email || (_vm.user.user_email == ''))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data_user.user_email),
      expression: "data_user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.data_user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data_user.user_email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.data_processing_message != '') ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.editProfileDetails()
      }
    }
  }, [_vm._v("Save Details \r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('blockquote', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("To change your Email or Phone Number, requires validation from your existing Phone Number or Email Address\r\n                  "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Proceed")])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-envelope"
  }), _vm._v(" "), _c('span', [_vm._v("Messages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" "), _c('span', [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-circle-xx",
    staticStyle: {
      "float": "right",
      "text-align": "center",
      "margin-top": "1em"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px",
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0",
      "margin-top": "-1.62em",
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "text-align": "center",
      "border-radius": "5px",
      "line-height": "0.8",
      "font-size": "14px",
      "background-color": "#000000",
      "color": "#f5f5f5"
    },
    attrs: {
      "href": "/manage/profile"
    }
  }, [_vm._v("Set")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("My Orders")]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Places I order from")]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/settings"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Store Settings ")]), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-envelope"
  }), _vm._v(" "), _c('span', [_vm._v("My Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/placed/orders"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("My Orders")])]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/places/orders"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-store-alt"
  }), _vm._v(" "), _c('span', [_vm._v("Places I ORDER from")])]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-key"
  }), _vm._v(" "), _c('span', [_vm._v("Reset Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/support"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-support"
  }), _vm._v(" "), _c('span', [_vm._v("Support")])]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-envelope"
  }), _vm._v(" "), _c('span', [_vm._v("Contact Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-motorcycle"
  }), _vm._v(" "), _c('span', [_vm._v("Delivery Locations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-bank"
  }), _vm._v(" "), _c('span', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu-box"
  }, [_c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/support"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_c('i', {
    staticClass: "fas fa-support"
  }), _vm._v(" "), _c('span', [_vm._v("Support")])]), _vm._v(" "), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/create/business"
    }
  }, [_c('span', {
    staticClass: "cb-left"
  }, [_vm._v("Set Up Business ")]), _c('span', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20921bdc"}!./src/pages/Components/SettingsManagement/template.html
// module id = 547
// module chunks = 0